import React from "react";
import "./buttons.css";
import backButtons from "../../assets/icons/backButtons.svg";
import { LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
function BottomButtons({
  backHandler,
  nextHandler,
  bottom,
  text="Next",
  nextBtnLoading,
  nextButtonText = "Invite",
  backButtonText = "Back",
}) {
  const dimension = window.innerWidth;
  return (
    <div
      className="BottomButtonsParentContainer"
      style={
        dimension > 768
          ? { bottom: bottom ? "-4rem" : 0, position: "absolute" }
          : {}
      }
    >
      <div className="buttonsRowContainer">
        <Row className={"Btns-row1"}>
          {dimension > 768 && (
            <Col lg={11} xs={24} md={10} className={"Back-btn-div"}>
              <Button className="Back-btn" onClick={backHandler}>
                {backButtonText}
              </Button>
            </Col>
          )}
          {dimension > 768 && <div className="temp-gap-div"></div>}
          {dimension > 768 && (
            <Col lg={11} xs={24} md={10} className="Next-btn-div">
              <Button
                className="Next-btn"
                onClick={nextHandler}
                // disabled={nextBtnLoading}
              >
                <span className="btn-read-rules1">{nextBtnLoading? <LoadingOutlined/> : text}</span>
              </Button>
            </Col>
          )}
          {dimension <= 768 ? (
            <div className="main-div-mobile">
              <div className="button-mob-view">
                <button onClick={backHandler} className="back-btn-mobile">
                  <img src={backButtons} />
                </button>
                <Button
                  onClick={nextHandler}
                  className="next-btn-mobile"
                >
                 <span>
                 <span className="btn-read-rules1">{nextBtnLoading? <LoadingOutlined/> : text}</span>
                 </span> 
                </Button>
              </div>
            </div>
          ) : null}
        </Row>
      </div>
    </div>
  );
}

export default BottomButtons;
